<template>
  <p><slot></slot></p>
</template>

<script>
export default {
  name: "BaseParagraph"
}
</script>

<style scoped>
  p {
    font-size: 15px;
    line-height: 1.5;
    color: #717171;
  }
</style>